import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import ReCaptcha from 'react-recaptcha';
import Config from '../../config';
import gql from 'nanogql';

export default class extends React.Component {

  state = {
    back: false,
    reCAPTCHAKey: '',
    recaptchaResponse: '',
    name: '',
    phone: '',
    email: '',
    message: '',
    submitted: false
  };

  constructor(props) {
    super(props);

    this.state.reCAPTCHAKey = Config.getReCAPTCHAKey();
  }

  async handleSubmit(event) {
    event.preventDefault();

    const promise = new Promise((resolve) => this.setState({
      loading: true
    }, resolve));

    const query = gql`
        mutation Mutation($input: CreateSubmissionInput!) {
            createSubmission(input: $input)
        }
    `;

    const input = {
      name: this.state.name,
      phone: this.state.phone,
      email: this.state.email,
      message: this.state.message,
      recaptchaResponse: this.state.recaptchaResponse,
      domain: location.host
    };

    if (this.props.match.params.group && this.props.match.params.group !== 'default') {
      input.group = this.props.match.params.group;
    }

    if (this.props.match.params.key && this.props.match.params.key !== 'none') {
      input.key = this.props.match.params.key;
    }

    const response = await fetch('https://api.reviews.nzdigital.co.nz/graphql', {
      method: 'POST',
      body: JSON.stringify(query({
        input
      })),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const json = await response.json();

    const success = json.data.createSubmission;

    await promise;

    return new Promise((resolve) => this.setState({
      loading: false,
      submitted: success,
      error: !success
    }, resolve))
  }

  render() {
    return (
      <div className="content-inner-container bad-times">
        <div className="bad-times-inner">
          <div className="back" onClick={() => this.setState({ back: true })}>
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </div>
          <i className="fa fa-meh-o" />
          <p>
            <strong>We strive for 100% customer satisfaction.</strong>
          </p>
          <p>
            If we fell short, please tell us more so we can address your concerns.
          </p>
          <div className="controls-holder">
            <div className="controls-holder-inner">
              <input type="text" placeholder="Name" onChange={(event) => this.setState({ name: event.target.value })} />
              <input type="text" placeholder="Email" onChange={(event) => this.setState({ email: event.target.value })} />
              <input type="text" placeholder="Phone" onChange={(event) => this.setState({ phone: event.target.value })} />
              <textarea placeholder="Enter Message" onChange={(event) => this.setState({ message: event.target.value })} />
              <ReCaptcha elementID="g-recaptcha" sitekey={this.state.reCAPTCHAKey} verifyCallback={(response) => this.setState({ recaptchaResponse: response })} size="normal" />
              <ReCaptcha elementID="g-recaptcha-compact" sitekey={this.state.reCAPTCHAKey} verifyCallback={(response) => this.setState({ recaptchaResponse: response })} size="compact" />
            </div>
          </div>
          <div className="submit-holder">
            <button disabled={this.state.loading || !(this.state.email && this.state.name && this.state.phone && this.state.message && this.state.recaptchaResponse)} onClick={this.handleSubmit.bind(this)}>
              Send us your feedback
            </button>
            {
              this.state.loading ? (
                <div className="spinner" />
              ) : null
            }
          </div>
        </div>
        {
          this.state.back ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}`} />
          ) : null
        }
        {
          this.state.submitted ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/feedback/thank-you`} />
          ) : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/states/bad-times/index.js